
import Vue from 'vue';
// import { createApp } from "vue";
import VueProgressBar from 'vue-progressbar';
import Vuelidate from 'vuelidate';
import VueSession from 'vue-session';

import VueGtag from 'vue-gtag';
import { getGAid } from '@/utils/env';
import App from './App.vue';
import store from './store';
import router from './router';

import './index.css'; // tailwind
import '@/assets/sass/style.scss';
// Custom component
import VueButton from './components/ui/Button/Button.vue';
import VueSearch from './components/ui/Input/Search.vue';
import VueBox from './components/ui/Box/Box.vue';
import VueHeading from './components/ui/Heading/Heading.vue';
import VueDivider from './components/ui/Divider.vue';
import VueInput from './components/ui/Input/Input.vue';
import VueAccordian from './components/ui/Accordian/Accordian.vue';
import VueAlert from './components/ui/Alert/Alert.vue';
import VueCheckbox from './components/ui/Input/Checkbox.vue';
import VueSelect from './components/ui/Input/Select.vue';
import VueSelectAutoComplete from './components/ui/Lib/BaseSelectAutocomplete.vue';
import VueModal from './components/ui/Modal/Modal.vue';

Vue.component('vue-button', VueButton);
Vue.component('vue-search', VueSearch);
Vue.component('vue-box', VueBox);
Vue.component('vue-heading', VueHeading);
Vue.component('vue-divider', VueDivider);
Vue.component('vue-input', VueInput);
Vue.component('vue-accordian', VueAccordian);
Vue.component('vue-alert', VueAlert);
Vue.component('vue-checkbox', VueCheckbox);
Vue.component('v-autocomplete-select', VueSelectAutoComplete);
Vue.component('vue-select', VueSelect);
Vue.component('vue-modal', VueModal);

Vue.use(Vuelidate);
Vue.use(VueSession);
Vue.use(VueProgressBar, {
  color: '#438ede',
  failedColor: 'red',
  thickness: '5px',
});

Vue.config.productionTip = false;


Vue.use(VueGtag, {
  config: { id: getGAid() },
  bootstrap: false,
}, router);

export default new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
